var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-clocked-out"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clocked-out",
    clipPath: "url(#clip-clocked-out)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32866",
    "data-name": "Group 32866",
    transform: "translate(-3315.865 13492.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11154",
    "data-name": "Ellipse 11154",
    transform: "translate(3315.865 -13492.611)",
    fill: "#ef717d",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M11.078,18.546v3.379a.71.71,0,0,1-.7.739H.739A.741.741,0,0,1,0,21.925V9.739A.741.741,0,0,1,.739,9h9.638a.71.71,0,0,1,.7.739v3.379a.739.739,0,0,1-1.477,0v-2.64H1.477V21.186H9.6v-2.64a.739.739,0,0,1,1.477,0Zm5.687-3.268-2.88-2.917a.744.744,0,0,0-1.052,1.052l1.643,1.662-8.955.018a.739.739,0,1,0,0,1.477l8.955-.018-1.643,1.662a.752.752,0,0,0,0,1.052.729.729,0,0,0,.517.222.7.7,0,0,0,.517-.222l2.9-2.917A.758.758,0,0,0,16.765,15.278Z",
    transform: "translate(3322.372 -13493.443)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockedOut);
export default __webpack_public_path__ + "static/media/clocked-out.5dfc1e0407e5ff1510d852bc83ffc4f2.svg";
export { ForwardRef as ReactComponent };